<template>
    <div class="order-progress-wrap">
        <div class="breadBox">
            <el-button class="backBtn" @click="back"><i class="el-icon-arrow-left"></i> 返回</el-button>
            <div class="breadItem"><span>订单管理</span></div>
            <div class="breadItem"><span>订单列表</span></div>
            <div class="breadItem"><span>订单进度编辑</span></div>
        </div>
        
        <div class="order-header">
            <div class="mod-title">基础信息</div>
            <div> 订单名称： {{fdInfo.order_name}}</div>
            <div> 订单编号： {{fdInfo.order_number}}</div>
            <!-- <div> 发单方： {{fdInfo.order_name}}</div> -->
            <div> 总数： {{fdInfo.order_quantity}} 件</div>
        </div>

        <div class="order-btns-wrap">
            <div class="mod-title">订单状态操作</div>
            <div class="cancel-btn">
                <el-button type="danger" size="small" @click="managerCancelReasonShow = true">取消订单</el-button>

                <span class="status">当前订单状态：<strong class="act">{{fdInfo.order_status | turnValToText("order_status")}}</strong> </span>
            </div>
            <div class="steps">
                <div class="items">
                   <!-- 待补充详细资料 10500
                        待品牌商上传合同 12100
                        待生产商确认合同 12300
                        待品牌商上传定金支付凭证 12900
                        待生产商确认定金支付凭证 13000
                        待生产商交付大货 13700
                        待品牌商验收成衣 16700
                        待生产商确认验收结果 18300
                        待品牌商支付交货款 18700
                        待生产商确认交货款 18800
                        待品牌商支付尾款 19300
                        待生产商确认尾款 19400
                        待订单评价 19600
                        品牌商已评价 19710
                        生产商已评价 19720
                        完成 19800
                        已取消 19900 -->
                    <div class="btn">
                         <el-button type="primary" size="small" @click="fdAddInfoShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 10500">补充详细资料</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="fdUploadContractShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 12100">上传合同</el-button> <br>
                    </div>
                </div>
                <div class="items">
                   
                    <div class="btn">
                         <el-button type="primary" size="small" @click="checkInfo('jd_check_contract')" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 12300">确认合同</el-button> <br>
                    </div>
                </div>
                <div class="items">

                    <div class="btn">
                        <el-button type="primary" size="small" @click="fdPayAdvanceVoucherShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 12900 || fdInfo.advance_payment_percent == 0">上传定金支付凭证</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="checkInfo('jd_check_pay_advance_voucher')" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 13000 || fdInfo.advance_payment_percent == 0">确认定金支付凭证</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="jdDeliverGoodsShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 13700">交付大货</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="fdAcceptanceResultShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 16700">验收成衣</el-button> <br>
                    </div>
                </div>
                <div class="items">
                   
                    <div class="btn">
                         <el-button type="primary" size="small" @click="getSureResultData" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 18300">确认验收结果</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="fdPayDeliveryVoucherShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 18700 || fdInfo.delivery_payment_percent == 0">提交交货款支付凭证</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="checkInfo('jd_check_pay_delivery_voucher')" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 18800 || fdInfo.delivery_payment_percent == 0">确认交货款</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="fdPayFinalVoucherShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 19300 || fdInfo.tail_payment_percent == 0">提交尾款</el-button> <br>
                    </div>
                </div>
                <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="checkInfo('jd_check_pay_tail_voucher')" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status > 19400 || fdInfo.tail_payment_percent == 0">确认尾款</el-button> <br>
                    </div>
                </div>
                <!-- <div class="items">
                    
                    <div class="btn">
                         <el-button type="primary" size="small" @click="fdCommentShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status >= 19710">品牌商对生产商评价</el-button> <br>
                         <el-button type="primary" size="small" @click="jdCommentShow = true" :disabled="fdInfo.order_status <= 10300 || fdInfo.order_status >= 19720">生产商对品牌商评价</el-button>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="content">
            <div class="content-item">
                <div class="mod-title">发单方（品牌商） - 订单动态</div>
                <!-- <div class="title">发单方 - <span class="status">{{fdInfo.order_status | turnValToText("order_status")}}</span></div>
                <div class="mod-title">可操作按钮</div>
                <div class="btns">
                    <el-row>
                        <el-col :span="12"><el-button type="text" :disabled="!(fdInfo.order_status==10100 || fdInfo.order_status==10200 || fdInfo.order_status==10300)">取消订单</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="fdAddInfoShow = true" :disabled="fdInfo.order_status!=10500">补充详细资料</el-button></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"><el-button type="text" @click="fdUploadContractShow = true" :disabled="!(fdInfo.order_status==10500 || fdInfo.order_status==12100)">上传合同</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="fdPayAdvanceVoucherShow = true" :disabled="!((fdInfo.order_status==10500 || fdInfo.order_status==12100 || fdInfo.order_status==12300 ||fdInfo.order_status==12900) && fdInfo.advance_payment_percent > 0)">上传定金支付凭证</el-button></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"><el-button type="text" @click="acceptanceResultShow = true"  :disabled="fdInfo.order_status!=16700">验收成衣</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="fdPayDeliveryVoucherShow = true" :disabled="!((fdInfo.order_status==13700 || fdInfo.order_status==16700 || fdInfo.order_status==18300 || fdInfo.order_status==18700 || ((fdInfo.order_status==10500 || fdInfo.order_status==12100 || fdInfo.order_status==12300 ||fdInfo.order_status==12900) && fdInfo.advance_payment_percent === 0) ) && fdInfo.delivery_payment_percent > 0)">上传交货款支付凭证</el-button></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"><el-button type="text" @click="fdPayFinalVoucherShow = true" :disabled="!((fdInfo.order_status==19300 || ((fdInfo.order_status==10500 || fdInfo.order_status==12100 || fdInfo.order_status==12300 ||fdInfo.order_status==12900) && fdInfo.advance_payment_percent === 0 && fdInfo.delivery_payment_percent === 0) || ((fdInfo.order_status==13700 || fdInfo.order_status==16700 || fdInfo.order_status==18300 || fdInfo.order_status==18700) && fdInfo.delivery_payment_percent === 0)) && fdInfo.tail_payment_percent > 0)">提交尾款支付凭证</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="fdCommentShow = true" :disabled="!(fdInfo.order_status==19600 || fdInfo.order_status==19720)">对厂家评价</el-button></el-col>
                    </el-row>
                </div>
                <div class="mod-title">订单进度</div> -->
                <div class="progress">
                    <el-timeline>
                        <el-timeline-item
                            v-for="(item, i) in fdOrderDynamics"
                            :key="i"
                            :timestamp="item.record_time"
                            color="#3d465a"
                        >
                            <span v-for="(ele, j) in item.log_text.text" :key="j" :class="{'active-text':ele.type=='button'}" @click="seeDynamicsDetail(ele.link)">{{ele.str}}</span>
                            <i v-if="item.isAdmin" class="el-icon-user-solid admin-flag" title="管理员操作"></i>
                        </el-timeline-item>
                    </el-timeline>
                    <div class="no-dynamics" v-if="fdOrderDynamics.length == 0"> <i class="el-icon-document"></i> 暂无进度</div>
                </div>
            </div>

            <div class="content-item">
                <div class="mod-title">接单方（生产商） - 订单动态</div>
                <!-- <div class="title">接单方 - <span class="status">{{jdInfo.order_status | turnValToText("order_status")}}</span></div>
                <div class="mod-title">可操作按钮</div>
                <div class="btns">
                    <el-row>
                        <el-col :span="12"><el-button type="text" :disabled="jdInfo.order_status!=10300">取消订单</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="checkInfo('jd_check_contract')" :disabled="jdInfo.order_status!=12300">确认合同</el-button></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"><el-button type="text" @click="checkInfo('jd_check_pay_advance_voucher')" :disabled="jdInfo.order_status!=13000">确认定金支付凭证</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="jdDeliverGoodsShow = true" :disabled="jdInfo.order_status!=13700">交付大货</el-button></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"><el-button type="text" @click="getSureResultData" :disabled="jdInfo.order_status!=18300">确认验收结果</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="checkInfo('jd_check_pay_delivery_voucher')" :disabled="jdInfo.order_status!=18800">确认交货款支付凭证</el-button></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"><el-button type="text" @click="checkInfo('jd_check_pay_tail_voucher')" :disabled="jdInfo.order_status!=19400">确认尾款支付凭证</el-button></el-col>
                        <el-col :span="12"><el-button type="text" @click="jdCommentShow = true" :disabled="jdInfo.order_status!=19600 && jdInfo.order_status!=19710">对商家进行评价</el-button></el-col>
                    </el-row>
                </div>
                <div class="mod-title">订单进度</div> -->
                <div class="progress">
                    <el-timeline>
                        <el-timeline-item
                            v-for="(item, index) in jdOrderDynamics"
                            :key="index"
                            :timestamp="item.timestamp"
                            color="#3d465a"
                        >
                            <span v-for="(ele, j) in item.log_text.text" :key="j" :class="{'active-text':ele.type=='button'}" @click="seeDynamicsDetail(ele.link)">{{ele.str}}</span>  
                            <i v-if="item.isAdmin" class="el-icon-user-solid admin-flag" title="管理员操作"></i>
                        </el-timeline-item>
                    </el-timeline>
                    <div class="no-dynamics" v-if="jdOrderDynamics.length == 0"><i class="el-icon-document"></i>暂无进度</div>
                </div>
            </div>
        </div>

        <!-- 补充详细资料 -->
        <el-dialog 
            title="补充详细资料"
            :visible.sync="fdAddInfoShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="fdAddInfo.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="工艺单图片说明">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 33101,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdAddInfo.processSheet"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdAddInfo', 'processSheet')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdAddInfo', 'processSheet')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>

                <el-form-item label="尺寸表图片说明">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 33201,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdAddInfo.sizeChart"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdAddInfo', 'sizeChart')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdAddInfo', 'sizeChart')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>

                <el-form-item label="查货方式图片说明">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 33301,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdAddInfo.checkGoodsType"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdAddInfo', 'checkGoodsType')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdAddInfo', 'checkGoodsType')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>

                <el-form-item label="查货方式">
                    <el-radio-group v-model="fdAddInfo.inspectionMethod">
                        <el-radio label="发单方自检"></el-radio>
                        <el-radio label="生产商自检"></el-radio>
                        <el-radio label="第三方检查"></el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="查货比例" v-if="fdAddInfo.inspectionMethod == '发单方自检'">
                    <el-select v-model="fdAddInfo.proportionOfInspection" placeholder="请选择查货比例">
                        <el-option v-for="(item, index) in 100" :key="index" :label="item+'%'" :value="item"></el-option>
                    
                    </el-select>
                </el-form-item>

                <el-form-item label="发单方自检方式" v-if="fdAddInfo.inspectionMethod == '发单方自检'">
                    <el-radio-group v-model="fdAddInfo.selfTestMethod">
                        <el-radio label="发单方去厂家查货物"></el-radio>
                        <el-radio label="生产商发货到发单方指定地点查货"></el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="质检要求" v-if="fdAddInfo.inspectionMethod == '发单方自检'">
                    <el-input type="textarea" :rows="3" v-model="fdAddInfo.qualityInspectionRequirements" placeholder="请输入您的质检要求,1000字以内"></el-input>
                </el-form-item>

                <el-form-item label="生产商自检要求（生产商需要出具验货报告）" v-if="fdAddInfo.inspectionMethod == '生产商自检'">
                    <el-input type="textarea" :rows="3" v-model="fdAddInfo.manufacturerSelfTestRequirements" placeholder="请填写您对生产商的质检标准，如工艺单、尺寸表等内容要求,1000字以内"></el-input>
                </el-form-item>

                <el-form-item label="第三方检查要求" v-if="fdAddInfo.inspectionMethod == '第三方检查'">
                    <el-input type="textarea" :rows="3" v-model="fdAddInfo.thirdPartyInspectionRequirements" placeholder="请填写您对第三方的质检标准，如工艺单、尺寸表等内容要求,1000字以内"></el-input>
                </el-form-item>

                <el-form-item label="补充备注">
                    <el-input type="textarea" :rows="3"  v-model="fdAddInfo.additionalMaterialsRemark" placeholder="请填写您的其他需求，1000字以内"></el-input>
                </el-form-item>

                <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3" v-model="fdAddInfo.additionalMaterialsAdminRemark" placeholder="请填写管理员备注信息（必填）"></el-input>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fdAddInfoShow = false">取 消</el-button>
                <el-button type="primary" @click="fdAddInfoSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 上传合同 -->
        <el-dialog 
            title="上传合同"
            :visible.sync="fdUploadContractShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="fdUploadContract.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传合同图片或扫描件（合同图片或扫描件需要盖章）">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 34201,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdUploadContract.contractImgs"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdUploadContract', 'contractImgs')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdUploadContract', 'contractImgs')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>
            
                <el-form-item label="合同备注">
                    <el-input type="textarea" :rows="3"  v-model="fdUploadContract.contractRemark" placeholder="您可在此输入合同备注"></el-input>
                </el-form-item>

                <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="fdUploadContract.contractAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fdUploadContractShow = false">取 消</el-button>
                <el-button type="primary" @click="fdUploadContractSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 上传定金支付凭证 -->
        <el-dialog 
            title="上传定金支付凭证"
            :visible.sync="fdPayAdvanceVoucherShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="fdPayAdvanceVoucher.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传预付款（定金）支付凭证图片">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 34301,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdPayAdvanceVoucher.advancePayImgs"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdPayAdvanceVoucher', 'advancePayImgs')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdPayAdvanceVoucher', 'advancePayImgs')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>
            
                <el-form-item label="预付款(定金)支付备注">
                    <el-input type="textarea" :rows="3"  v-model="fdPayAdvanceVoucher.prepaymentRemark" placeholder="您可在此输入预付款（定金）支付备注"></el-input>
                </el-form-item>

                <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="fdPayAdvanceVoucher.prepaymentAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fdPayAdvanceVoucherShow = false">取 消</el-button>
                <el-button type="primary" @click="fdPayAdvanceVoucherSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 上传交货款支付凭证 -->
        <el-dialog 
            title="上传交货款支付凭证"
            :visible.sync="fdPayDeliveryVoucherShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="fdPayDeliveryVoucher.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传交货款支付凭证图片">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 34401,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdPayDeliveryVoucher.deliveryPayImgs"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdPayDeliveryVoucher', 'deliveryPayImgs')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdPayDeliveryVoucher', 'deliveryPayImgs')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>
            
                <el-form-item label="交货款支付备注">
                    <el-input type="textarea" :rows="3"  v-model="fdPayDeliveryVoucher.deliveryRemark" placeholder="您可在此输入交货款支付备注"></el-input>
                </el-form-item>

                 <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="fdPayDeliveryVoucher.deliveryAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fdPayDeliveryVoucherShow = false">取 消</el-button>
                <el-button type="primary" @click="fdPayDeliveryVoucherSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 提交验收结果 -->
        <el-dialog 
            title="提交验收结果"
            :visible.sync="fdAcceptanceResultShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="fdAcceptanceResult.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">

                <el-form-item label="不合格数量">
                    <el-input type="number" v-model="fdAcceptanceResult.unqualifiedQuantity" placeholder="您可在此输入不合格数量"></el-input>
                </el-form-item>
                <el-form-item label="总数">
                    <el-input type="number" v-model="fdAcceptanceResult.goodsTotal" placeholder="您可在此输入总数"></el-input>
                </el-form-item>
                <el-form-item label="上传验收图片">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 34601,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdAcceptanceResult.checkImgs"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdAcceptanceResult', 'checkImgs')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdAcceptanceResult', 'checkImgs')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>
            
                <el-form-item label="备注说明">
                    <el-input type="textarea" :rows="3"  v-model="fdAcceptanceResult.acceptanceResultsDescription" placeholder="您可在此输入备注说明"></el-input>
                </el-form-item>
                <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="fdAcceptanceResult.submitAcceptanceResultsAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fdAcceptanceResultShow = false">取 消</el-button>
                <el-button type="primary" @click="fdAcceptanceResultSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 上传尾款支付凭证 -->
        <el-dialog 
            title="上传尾款支付凭证"
            :visible.sync="fdPayFinalVoucherShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="fdPayFinalVoucher.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传尾款支付凭证图片">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 34501,
					        imageUserId: fdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="fdPayFinalVoucher.finalPayImgs"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'fdPayFinalVoucher', 'finalPayImgs')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'fdPayFinalVoucher', 'finalPayImgs')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>
            
                <el-form-item label="尾款支付备注">
                    <el-input type="textarea" :rows="3"  v-model="fdPayFinalVoucher.tailRemark" placeholder="您可在此输入尾款支付备注"></el-input>
                </el-form-item>

                <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="fdPayFinalVoucher.tailAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fdPayFinalVoucherShow = false">取 消</el-button>
                <el-button type="primary" @click="fdPayFinalVoucherSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 发单方 - 对厂家评价 -->
        <el-dialog 
            title="对厂家评价"
            :visible.sync="fdCommentShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="fdComment.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="100px">
                <el-form-item label="评分">
                    <el-rate
                        v-model="fdComment.stars"
                        show-text
                        :texts="fdComment.texts"
                    >
                    </el-rate>
                </el-form-item>
                <el-form-item label="评语">
                    <el-input type="textarea" :rows="3"  v-model="fdComment.evaluationMsg" placeholder="您可在此输入您的评语"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fdCommentShow = false">取 消</el-button>
                <el-button type="primary" @click="fdCommentSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 接单方 - 确认合同 -->
        <el-dialog 
            title="确认合同"
            :visible.sync="jdCheckContractShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="jdCheckContract.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的合同图片或扫描件：">
                    <viewer :images="jdCheckContract.contractRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in jdCheckContract.contractRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in jdCheckContract.contractRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="jdCheckContract.contractRemarkImg && jdCheckContract.contractRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="合同备注：">
                    <span>{{jdCheckContract.contractRemark ? jdCheckContract.contractRemark : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="jdCheckContract.confirmContractAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jdCheckContractShow = false">取 消</el-button>
                <el-button type="primary" @click="jdCheckContractSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 接单方 - 确认定金支付凭证 -->
        <el-dialog 
            title="确认定金支付凭证"
            :visible.sync="jdCheckPayAdvanceVoucherShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="jdCheckPayAdvanceVoucher.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片或扫描件：">
                    <viewer :images="jdCheckPayAdvanceVoucher.paymentRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in jdCheckPayAdvanceVoucher.paymentRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in jdCheckPayAdvanceVoucher.paymentRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="jdCheckPayAdvanceVoucher.paymentRemarkImg && jdCheckPayAdvanceVoucher.paymentRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{jdCheckPayAdvanceVoucher.prepaymentRemark ? jdCheckPayAdvanceVoucher.prepaymentRemark : '未填写'}}</span>
                </el-form-item>

                 <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="jdCheckPayAdvanceVoucher.confirmCertificateAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jdCheckPayAdvanceVoucherShow = false">取 消</el-button>
                <el-button type="primary" @click="jdCheckPayAdvanceVoucherSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 接单方 - 交付大货 -->
        <el-dialog 
            title="交付大货"
            :visible.sync="jdDeliverGoodsShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="jdDeliverGoods.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">

                <el-form-item label="交付大货件数">
                    <el-input type="number" v-model="jdDeliverGoods.deliverQuantity" placeholder="您可在此输入交付大货件数"></el-input>
                </el-form-item>
                <el-form-item label="上传大货图片">
                    <el-upload
                        name="files"
                        :action="uploadUrl"
                        :data="{
                            imageType: 34801,
					        imageUserId: jdUserId,
                        }"
                        list-type="picture-card"
                        :file-list="jdDeliverGoods.deliverLargeGoodsImgs"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="function(file, fileList){ return handleRemove(file, fileList,'jdDeliverGoods', 'deliverLargeGoodsImgs')}"
                        :before-upload ="beforeUpload"
                        :on-success="function(res,file, fileList){ return onSuccess(res,file, fileList,'jdDeliverGoods', 'deliverLargeGoodsImgs')}"
                        :on-error="onError"
                        accept="image/png, image/jpeg, image/jpg"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="el-upload__tip">注：建议图片为.png或.jpg格式, 大小不超过10M</div>
                </el-form-item>

                <el-form-item label="备注说明：">
                    <el-input type="textarea" :rows="3"  v-model="jdDeliverGoods.deliverDescription" placeholder="您可在此输入备注说明"></el-input>
                </el-form-item>

                 <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="jdDeliverGoods.deliverLargeGoodsAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jdDeliverGoodsShow = false">取 消</el-button>
                <el-button type="primary" @click="jdDeliverGoodsSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 接单方 - 确认验收结果 -->
        <el-dialog 
            title="确认验收结果"
            :visible.sync="jdSureResultShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="jdSureResult.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的图片：">
                    <viewer :images="jdSureResult.acceptanceImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in jdSureResult.acceptanceImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in jdSureResult.acceptanceImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="jdSureResult.acceptanceImg && jdSureResult.acceptanceImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="不合格数量">
                    <span>{{jdSureResult.quantity == '' ? '--' : jdSureResult.quantity}} 件</span>
                </el-form-item>

                <el-form-item label="总数">
                    <span>{{jdSureResult.goodsTotal== '' ? '--' : jdSureResult.goodsTotal}} 件</span>
                </el-form-item>

                <el-form-item label="不合格占比">
                    <span>{{jdSureResult.rejectRatio == '' ? '--' : jdSureResult.rejectRatio}} %</span>
                </el-form-item>

                <el-form-item label="备注说明：">
                    <span>{{jdSureResult.description ? jdSureResult.description : '未填写'}}</span>
                </el-form-item>

                 <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="jdSureResult.confirmAcceptanceResultsAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jdSureResultShow = false">取 消</el-button>
                <el-button type="primary" @click="jdSureResultSubmit">确 定</el-button>
            </div>
        </el-dialog>


        <!-- 接单方 - 确认交货款支付凭证 -->
        <el-dialog 
            title="确认交货款支付凭证"
            :visible.sync="jdCheckPayDeliveryVoucherShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="jdCheckPayDeliveryVoucher.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片或扫描件：">
                    <viewer :images="jdCheckPayDeliveryVoucher.deliveryRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in jdCheckPayDeliveryVoucher.deliveryRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in jdCheckPayDeliveryVoucher.deliveryRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="jdCheckPayDeliveryVoucher.deliveryRemarkImg && jdCheckPayDeliveryVoucher.deliveryRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{jdCheckPayDeliveryVoucher.deliveryRemark ? jdCheckPayDeliveryVoucher.deliveryRemark : '未填写'}}</span>
                </el-form-item>

                 <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="jdCheckPayDeliveryVoucher.confirmDeliveryAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jdCheckPayDeliveryVoucherShow = false">取 消</el-button>
                <el-button type="primary" @click="jdCheckPayDeliveryVoucherSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 接单方 - 确认尾款支付凭证 -->
        <el-dialog 
            title="确认尾款支付凭证"
            :visible.sync="jdCheckPayTailVoucherShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="jdCheckPayTailVoucher.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片或扫描件：">
                    <viewer :images="jdCheckPayTailVoucher.tailRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in jdCheckPayTailVoucher.tailRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in jdCheckPayTailVoucher.tailRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="jdCheckPayTailVoucher.tailRemarkImg && jdCheckPayTailVoucher.tailRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{jdCheckPayTailVoucher.tailRemark ? jdCheckPayTailVoucher.tailRemark : '未填写'}}</span>
                </el-form-item>

                 <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="jdCheckPayTailVoucher.confirmConfirmTailAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jdCheckPayTailVoucherShow = false">取 消</el-button>
                <el-button type="primary" @click="jdCheckPayTailVoucherSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 接单方 - 对品牌商评价 -->
        <el-dialog 
            title="对品牌商评价"
            :visible.sync="jdCommentShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="jdComment.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="100px">
                <el-form-item label="评分">
                    <el-rate
                        v-model="jdComment.stars"
                        show-text
                        :texts="jdComment.texts"
                    >
                    </el-rate>
                </el-form-item>
                <el-form-item label="评语">
                    <el-input type="textarea" :rows="3"  v-model="jdComment.evaluationMsg" placeholder="您可在此输入您的评语"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jdCommentShow = false">取 消</el-button>
                <el-button type="primary" @click="jdCommentSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 取消订单 -->
        <el-dialog 
            title="取消订单"
            :visible.sync="managerCancelReasonShow"
            :close-on-click-modal = "false"
            v-loading.fullscreen="managerCancelReason.loading"
            element-loading-text="正在提交中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-form label-width="180px">
                <el-form-item label="管理员备注信息（必填）">
                    <el-input type="textarea" :rows="3"  v-model="managerCancelReason.cancelAdminRemark" placeholder="您可在此输入管理员备注信息（必填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="managerCancelReasonShow = false">取 消</el-button>
                <el-button type="primary" @click="managerCancelReasonSubmit">确 定</el-button>
            </div>
        </el-dialog>




        <!-- 图片预览弹框 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>


        <!-- ============================================ 查看详情 ==================================================== -->

        <!-- 查看合同 -->
        <el-dialog 
            title="查看合同"
            :visible.sync="seeContractShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的合同图片或扫描件：">
                    <viewer :images="seeContract.contractRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeContract.contractRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeContract.contractRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeContract.contractRemarkImg && seeContract.contractRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="合同备注：">
                    <span>{{seeContract.contractRemark ? seeContract.contractRemark : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seeContract.contractAdminRemark">
                    <span>{{seeContract.contractAdminRemark ? seeContract.contractAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeContractShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看定金支付凭证 -->
        <el-dialog 
            title="查看定金支付凭证"
            :visible.sync="seePayAdvanceVoucherShow" 
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seePayAdvanceVoucher.paymentRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seePayAdvanceVoucher.paymentRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seePayAdvanceVoucher.paymentRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seePayAdvanceVoucher.paymentRemarkImg && seePayAdvanceVoucher.paymentRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seePayAdvanceVoucher.prepaymentRemark ? seePayAdvanceVoucher.prepaymentRemark : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="管理员备注信息：" v-if="seePayAdvanceVoucher.prepaymentAdminRemark">
                    <span>{{seePayAdvanceVoucher.prepaymentAdminRemark ? seePayAdvanceVoucher.prepaymentAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seePayAdvanceVoucherShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看大货（成衣） -->
        <el-dialog 
            title="查看大货（成衣）"
            :visible.sync="seeGoodsShow"
        >
            <el-form label-width="180px">
                <el-form-item label="交付大货件数：">
                    <span>{{seeGoods.deliverQuantity ? seeGoods.deliverQuantity : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seeGoods.deliverImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeGoods.deliverImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeGoods.deliverImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeGoods.deliverImg && seeGoods.deliverImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seeGoods.deliverDescription ? seeGoods.deliverDescription : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="管理员备注信息：" v-if="seeGoods.deliverLargeGoodsAdminRemark">
                    <span>{{seeGoods.deliverLargeGoodsAdminRemark ? seeGoods.deliverLargeGoodsAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeGoodsShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看验收结果 -->
        <el-dialog 
            title="查看验收结果"
            :visible.sync="seeResultShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的图片：">
                    <viewer :images="seeResult.acceptanceImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeResult.acceptanceImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeResult.acceptanceImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeResult.acceptanceImg && seeResult.acceptanceImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="不合格数量：">
                    <span>{{seeResult.quantity == '' ? '--' : seeResult.quantity}} 件</span>
                </el-form-item>

                <el-form-item label="总数：">
                    <span>{{seeResult.goodsTotal== '' ? '--' : seeResult.goodsTotal}} 件</span>
                </el-form-item>

                <el-form-item label="不合格占比：">
                    <span>{{seeResult.rejectRatio == '' ? '--' : seeResult.rejectRatio}} %</span>
                </el-form-item>

                <el-form-item label="备注说明：">
                    <span>{{seeResult.description ? seeResult.description : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seeResult.submitAcceptanceResultsAdminRemark">
                    <span>{{seeResult.submitAcceptanceResultsAdminRemark ? seeResult.submitAcceptanceResultsAdminRemark : '未填写'}}</span>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeResultShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看交货款支付凭证 -->
        <el-dialog 
            title="查看交货款支付凭证"
            :visible.sync="seePayDeliveryVoucherShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seePayDeliveryVoucher.deliveryRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seePayDeliveryVoucher.deliveryRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seePayDeliveryVoucher.deliveryRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seePayDeliveryVoucher.deliveryRemarkImg && seePayDeliveryVoucher.deliveryRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seePayDeliveryVoucher.deliveryRemark ? seePayDeliveryVoucher.deliveryRemark : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="管理员备注信息：" v-if="seePayDeliveryVoucher.deliveryAdminRemark">
                    <span>{{seePayDeliveryVoucher.deliveryAdminRemark ? seePayDeliveryVoucher.deliveryAdminRemark : '未填写'}}</span>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seePayDeliveryVoucherShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看尾款支付凭证 -->
        <el-dialog 
            title="查看尾款支付凭证"
            :visible.sync="seePayTailVoucherShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seePayTailVoucher.tailRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seePayTailVoucher.tailRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seePayTailVoucher.tailRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seePayTailVoucher.tailRemarkImg && seePayTailVoucher.tailRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seePayTailVoucher.tailRemark ? seePayTailVoucher.tailRemark : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seePayTailVoucher.tailAdminRemark">
                    <span>{{seePayTailVoucher.tailAdminRemark ? seePayTailVoucher.tailAdminRemark : '未填写'}}</span>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seePayTailVoucherShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看评价 -->
        <el-dialog 
            title="查看评价"
            :visible.sync="seeCommentShow"
        >
            <el-form label-width="100px">
                <div style="margin-bottom: 20px" v-if="seeComment.comment_score">品牌商对生产商评价：</div>
                <el-form-item label="评分：" v-if="seeComment.comment_score">
                    <el-rate
                        v-model="seeComment.comment_score"
                        show-score
                        disabled
                        text-color="#ff9900"
                    >
                    </el-rate>
                </el-form-item>
                <el-form-item label="评语：" v-if="seeComment.comment_score">
                    <span>{{seeComment.comment_info ? seeComment.comment_info : '未填写'}}</span>
                </el-form-item>
                <div style="margin-bottom: 20px" v-if="seeComment.producer_comment_score">品牌商对生产商评价：</div>
                <el-form-item label="评分：" v-if="seeComment.producer_comment_score">
                    <el-rate
                        v-model="seeComment.producer_comment_score"
                        show-score
                        disabled
                        text-color="#ff9900"
                    >
                    </el-rate>
                </el-form-item>
                <el-form-item label="评语：" v-if="seeComment.producer_comment_score">
                    <span>{{seeComment.producer_comment_info ? seeComment.producer_comment_info : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeCommentShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看取消原因（生产商取消） -->
        <el-dialog 
            title="查看取消原因"
            :visible.sync="seeProducerCancelReasonShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seeProducerCancelReason.producerCancelImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeProducerCancelReason.producerCancelImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeProducerCancelReason.producerCancelImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeProducerCancelReason.producerCancelImg && seeProducerCancelReason.producerCancelImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seeProducerCancelReason.producerCancellationOfOrder ? seeProducerCancelReason.producerCancellationOfOrder : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeProducerCancelReasonShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看补充资料 -->
        <el-dialog 
            title="查看补充资料"
            :visible.sync="seeAdditionalDataShow"
        >
            <el-form label-width="180px">
                <el-form-item label="工艺单图片：">
                    <viewer :images="seeAdditionalData.technologyImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeAdditionalData.technologyImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeAdditionalData.technologyImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeAdditionalData.technologyImg && seeAdditionalData.technologyImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="尺码表图片：">
                    <viewer :images="seeAdditionalData.sizeTableImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeAdditionalData.sizeTableImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeAdditionalData.sizeTableImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeAdditionalData.sizeTableImg && seeAdditionalData.sizeTableImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="查货方式图片：">
                    <viewer :images="seeAdditionalData.checkGoodsImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeAdditionalData.checkGoodsImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeAdditionalData.checkGoodsImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeAdditionalData.checkGoodsImg && seeAdditionalData.checkGoodsImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="查货方式：">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.inspectionMethod ? seeAdditionalData.orderAdditionalMaterials.inspectionMethod : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="查货比例：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '发单方自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.proportionOfInspection ? seeAdditionalData.orderAdditionalMaterials.proportionOfInspection + '%' : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="发单方自检方式：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '发单方自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.selfTestMethod ? seeAdditionalData.orderAdditionalMaterials.selfTestMethod : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="质检要求：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '发单方自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.qualityInspectionRequirements ? seeAdditionalData.orderAdditionalMaterials.qualityInspectionRequirements : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="生产商自检要求：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '生产商自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.manufacturerSelfTestRequirements ? seeAdditionalData.orderAdditionalMaterials.manufacturerSelfTestRequirements : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="第三方检查要求：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '第三方检查'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.thirdPartyInspectionRequirements ? seeAdditionalData.orderAdditionalMaterials.thirdPartyInspectionRequirements : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="补充备注：">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.additionalMaterialsRemark ? seeAdditionalData.orderAdditionalMaterials.additionalMaterialsRemark : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seeAdditionalData.orderAdditionalMaterials.additionalMaterialsAdminRemark">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.additionalMaterialsAdminRemark ? seeAdditionalData.orderAdditionalMaterials.additionalMaterialsAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="seeAdditionalDataShow = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { ajaxPost, api } from '@/common/request.js'
    import { ajaxApp, api_app } from '@/common/request_app.js'
    
    export default {
        name: '',
        data() {
            return {
                orderNumber: '', // 订单号
                fdUserId: '', // 发单方 - userId
                jdUserId: '', // 接单方 - userId
                
                fdInfo: {}, // 发单方 - 订单信息
                jdInfo: {}, // 接单方 - 订单信息
                // 订单进度
                jdOrderDynamics: [],
                fdOrderDynamics: [],

                // 图片上传地址
                uploadUrl: api_app.baseUrl + '/file/uploadfilebatch',

                // 当前弹出框
                // currentDialog: '', // 当前弹框

                // 发单方 - 补充详细资料 fdAddInfo
                fdAddInfoShow: false, // 补充详细资料 - 弹出框显示
                fdAddInfo: {
                    loading: false,
                    inspectionMethod:  '',  // 查货方式
                    proportionOfInspection: '', // 查货比例
                    selfTestMethod: '', // 发单方自检方式
                    qualityInspectionRequirements:  '', // 发单方自检 - 质检要求
                    manufacturerSelfTestRequirements:  '', // 生产商自检要求
                    thirdPartyInspectionRequirements: '', // 第三方检查要求
                    additionalMaterialsRemark:  '', // 补充备注
                    additionalMaterialsAdminRemark: '',

                    processSheet: [], // 工艺单图片说明
                    sizeChart: [], // 尺寸表图片说明
                    checkGoodsType: [], // 查货方式图片说明
                },

                // 发单方 - 上传合同 fdUploadContract
                fdUploadContractShow: false,
                fdUploadContract: {
                    loading: false,
                    contractImgs: [],
                    contractRemark: '',
                    contractAdminRemark: ''
                },

                // 发单方 - 上传定金支付凭证
                fdPayAdvanceVoucherShow: false,
                fdPayAdvanceVoucher: {
                    loading: false,
                    advancePayImgs: [],
                    prepaymentRemark: '',
                    prepaymentAdminRemark: ''
                },
                // 发单方 - 提交验收结果
                fdAcceptanceResultShow: false,
                fdAcceptanceResult: {
                    loading: false,
                    acceptanceResultsDescription: '',
                    unqualifiedQuantity: '',
                    goodsTotal: '',
                    rejectRatio: '',
                    checkImgs: [],
                    submitAcceptanceResultsAdminRemark: ''
                },

                // 发单方 - 上传交货款支付凭证
                fdPayDeliveryVoucherShow: false,
                fdPayDeliveryVoucher: {
                    loading: false,
                    deliveryPayImgs: [],
                    deliveryRemark: '',
                    deliveryAdminRemark: ''
                },

                // 发单方 - 上传尾款支付凭证
                fdPayFinalVoucherShow: false,
                fdPayFinalVoucher: {
                    loading: false,
                    finalPayImgs: [],
                    tailRemark: '',
                    tailAdminRemark: ''
                },

                // 发单方 - 对厂家评价
                fdCommentShow: false,
                fdComment: {
                    loading: false,
                    stars: 0,
                    texts: ['很差', '较差', '一般', '满意', '非常满意'],
                    evaluationMsg: ''
                },

                // 接单方 - 对品牌商评价
                jdCommentShow: false,
                jdComment: {
                    loading: false,
                    stars: 0,
                    texts: ['很差', '较差', '一般', '满意', '非常满意'],
                    evaluationMsg: ''
                },

                // 接单方 - 确认合同
                jdCheckContractShow: false,
                jdCheckContract: {
                    loading: false,
                    contractRemarkImg: [],
                    contractRemark: '',
                    confirmContractAdminRemark: ''
                },

                // 接单方 - 确认定金支付凭证
                jdCheckPayAdvanceVoucherShow: false,
                jdCheckPayAdvanceVoucher: {
                    loading: false,
                    paymentRemarkImg: [],
                    prepaymentRemark: '',
                    confirmCertificateAdminRemark: ''
                },

                // 接单方 - 交付大货
                jdDeliverGoodsShow: false,
                jdDeliverGoods: {
                    loading: false,
                    deliverDescription: '',
                    deliverQuantity: '',
                    deliverLargeGoodsImgs: [],
                    deliverLargeGoodsAdminRemark: ''
                },

                // 接单方 - 确认验收结果
                jdSureResultShow: false,
                jdSureResult: {
                    loading: false,
                    acceptanceImg: [],
                    description: '',
                    goodsTotal: '',
                    quantity: '',
                    rejectRatio: '',
                    confirmAcceptanceResultsAdminRemark: ''
                },

                // 接单方 - 确认交货款支付凭证
                jdCheckPayDeliveryVoucherShow: false,
                jdCheckPayDeliveryVoucher: {
                    loading: false,
                    deliveryRemarkImg: [],
                    deliveryRemark: '',
                    confirmDeliveryAdminRemark: ''
                },

                // 接单方 - 确认尾款支付凭证
                jdCheckPayTailVoucherShow: false,
                jdCheckPayTailVoucher: {
                    loading: false,
                    tailRemarkImg: [],
                    tailRemark: '',
                    confirmConfirmTailAdminRemark: ''
                },

                // 取消订单
                managerCancelReasonShow: false,
                managerCancelReason: {
                    loading: false,
                    cancelAdminRemark: ''
                },


                dialogVisible: false, // 图片review 弹框
                dialogImageUrl: '',  // 图片review 地址

                // ==============================================

                // 查看合同
                seeContractShow: false,
                seeContract: {
                    contractRemarkImg: [],
                    contractRemark: '',
                    contractAdminRemark: ''
                },

                // 查看定金支付凭证
                seePayAdvanceVoucherShow: false,
                seePayAdvanceVoucher: {
                    paymentRemarkImg: [],
                    prepaymentRemark: '',
                    prepaymentAdminRemark: ''
                },

                // 查看大货
                seeGoodsShow: false,
                seeGoods: {
                    deliverDescription: '',
                    deliverQuantity: '',
                    deliverImg: [],
                    deliverLargeGoodsAdminRemark: ''
                },

                // 查看验收结果
                seeResultShow: false,
                seeResult: {
                    acceptanceImg: [],
                    description: '',
                    goodsTotal: '',
                    quantity: '',
                    rejectRatio: '',
                    submitAcceptanceResultsAdminRemark: ''
                },

                // 查看交货款支付凭证
                seePayDeliveryVoucherShow: false,
                seePayDeliveryVoucher: {
                    deliveryRemarkImg: [],
                    deliveryRemark: '',
                    deliveryAdminRemark:  ''
                },

                // 查看尾款支付凭证
                seePayTailVoucherShow: false,
                seePayTailVoucher: {
                    tailRemarkImg: [],
                    tailRemark: '',
                    tailAdminRemark: ''
                },

                // 查看评价
                seeCommentShow: false,
                seeComment: {
                    comment_score: 0,
                    comment_info: '',
                    producer_comment_score: 0,
                    producer_comment_info: '',
                },

                // 查看取消原因 (生产商取消)
                seeProducerCancelReasonShow: false,
                seeProducerCancelReason: {
                    producerCancelImg: [],
				    producerCancellationOfOrder: '',
                },

                // 查看补充资料
                seeAdditionalDataShow: false,
                seeAdditionalData: {
                    orderAdditionalMaterials: {},
                    technologyImg: [],
                    sizeTableImg: [],
                    checkGoodsImg: []
                }
                


            }
        },
        computed: {
        	IMG_PREV(){
        		return api.imgPrev
        	}
        },
        created() {
            this.getParam()
            this.getFdOrderProgress()
        },
        methods: {
            // 页面返回
            back(){
            	this.$router.back()
            },
            // 获取url参数
            getParam(){
            	this.orderNumber=this.$route.params.orderNumber
                this.fdUserId = this.$route.query.id
            },

            // 确认取消
            managerCancelReasonSubmit() {
                if (this.managerCancelReason.cancelAdminRemark === '') {
                    this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
                    return false;
                }

                this.cancelOrder();
            },

            cancelOrder() {
                this.$confirm('您确定取消订单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.managerCancelReason.loading = true;
                    ajaxPost('/admin/yijiajiaOrder/adminCancelOrder', {orderNumber: this.orderNumber, cancelAdminRemark: this.managerCancelReason.cancelAdminRemark}).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '取消订单成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.managerCancelReasonShow = false
                        } else {
                            this.$message({
                                message: '取消订单失败！',
                                type: 'warning'
                            })
                        }
                        this.managerCancelReason.loading = false;
                    }, err => {
                        console.log(err)
                        this.managerCancelReason.loading = false;
                    })
                })
            },


            // 发单方 - 补充详细资料提交
            fdAddInfoSubmit() {
                // if (
				// 	this.fdAddInfo.processSheet.length == 0 && 
				// 	this.fdAddInfo.sizeChart.length == 0 && 
				// 	this.fdAddInfo.checkGoodsType.length == 0 && 
				// 	this.fdAddInfo.inspectionMethod == '' &&
				// 	this.fdAddInfo.additionalMaterialsRemark == ''
				// ) {
				// 	this.$message({
                //         type: 'warning',
                //         message: '至少填写一项或添加补充备注信息!'
                //     })
				// 	return false;
                // }
                if (
					this.fdAddInfo.additionalMaterialsAdminRemark == ''
				) {
					this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
					return false;
                }
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fdAddInfo.loading = true;
                    let processSheet = [];
                    let sizeChart = [];
                    let checkGoodsType = [];
                
                    this.fdAddInfo.processSheet.forEach(item => {
                        processSheet = processSheet.concat(item.name);
                    });
                    this.fdAddInfo.sizeChart.forEach(item => {
                        sizeChart = sizeChart.concat(item.name);
                    });
                    this.fdAddInfo.checkGoodsType.forEach(item => {
                        checkGoodsType = checkGoodsType.concat(item.name);
                    });
                    let imageJson = [...processSheet, ...sizeChart, ...checkGoodsType]; 
                    let arg = {
                        userId: this.fdUserId,
                        orderNumber: this.orderNumber,
                        imageJson: JSON.stringify(imageJson) === '[]' ? '' : JSON.stringify(imageJson),
                        inspectionMethod: this.fdAddInfo.inspectionMethod,
                        proportionOfInspection: this.fdAddInfo.proportionOfInspection,
                        selfTestMethod: this.fdAddInfo.selfTestMethod,
                        qualityInspectionRequirements: this.fdAddInfo.qualityInspectionRequirements,
                        manufacturerSelfTestRequirements: this.fdAddInfo.manufacturerSelfTestRequirements,
                        thirdPartyInspectionRequirements: this.fdAddInfo.thirdPartyInspectionRequirements,
                        additionalMaterialsRemark: this.fdAddInfo.additionalMaterialsRemark,
                        additionalMaterialsAdminRemark: this.fdAddInfo.additionalMaterialsAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/additionalmaterials',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '补充资料提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.fdAddInfoShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.fdAddInfo.loading = false
                    }, err => {
                        this.fdAddInfo.loading = false
                        console.log(err)
                    })
                })
            },

            // 发单方 - 上传合同提交
            fdUploadContractSubmit() {
                // if (
				// 	this.fdUploadContract.contractImgs.length == 0 && this.fdUploadContract.contractRemark == ''
				// ) {
				// 	this.$message({
                //         type: 'warning',
                //         message: '至少填写一项!'
                //     })
				// 	return false;
                // }

                 if (
					this.fdUploadContract.contractAdminRemark == ''
				) {
					this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
					return false;
                }
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fdUploadContract.loading = true;

                    let contractImgs = [];		
                    console.log(this.fdUploadContract.contractImgs);
                    this.fdUploadContract.contractImgs.forEach(item => {
                        contractImgs = contractImgs.concat(item.name);
                    });

                    let arg = {
                        userId: this.fdUserId,
                        orderNumber: this.orderNumber,
                        imageJson: JSON.stringify(contractImgs) === '[]' ? '' : JSON.stringify(contractImgs),
                        contractRemark: this.fdUploadContract.contractRemark,
                        contractAdminRemark: this.fdUploadContract.contractAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/uploadContract',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.fdUploadContractShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.fdUploadContract.loading = false
                    }, err => {
                        this.fdUploadContract.loading = false
                        console.log(err)
                    })
                })
            },

            // 发单方 - 上传预付款（定金）支付凭证 提交
            fdPayAdvanceVoucherSubmit() {
                // if (
				// 	this.fdPayAdvanceVoucher.advancePayImgs.length == 0 && this.fdPayAdvanceVoucher.prepaymentRemark == ''
				// ) {
				// 	this.$message({
                //         type: 'warning',
                //         message: '至少填写一项!'
                //     })
				// 	return false;
                // }

                if (
					this.fdPayAdvanceVoucher.prepaymentAdminRemark == ''
				) {
					this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
					return false;
                }
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fdPayAdvanceVoucher.loading = true;

                    let advancePayImgs = [];		
                    console.log(this.fdPayAdvanceVoucher.advancePayImgs);
                    this.fdPayAdvanceVoucher.advancePayImgs.forEach(item => {
                        advancePayImgs = advancePayImgs.concat(item.name);
                    });

                    let arg = {
                        userId: this.fdUserId,
                        orderNumber: this.orderNumber,
                        imageJson: JSON.stringify(advancePayImgs) === '[]' ? '' : JSON.stringify(advancePayImgs),
                        prepaymentRemark: this.fdPayAdvanceVoucher.prepaymentRemark,
                        prepaymentAdminRemark: this.fdPayAdvanceVoucher.prepaymentAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/prepaymentCertificate',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.fdPayAdvanceVoucherShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.fdPayAdvanceVoucher.loading = false
                    }, err => {
                        this.fdPayAdvanceVoucher.loading = false
                        console.log(err)
                    })
                })
            },

            // 发单方 - 提交验收结果
            fdAcceptanceResultSubmit() {
                if (
					this.fdAcceptanceResult.submitAcceptanceResultsAdminRemark == ''
				) {
					this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
					return false;
                }
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fdAcceptanceResult.loading = true;

                    this.fdAcceptanceResult.unqualifiedQuantity = parseInt(this.fdAcceptanceResult.unqualifiedQuantity || 0 )
                    this.fdAcceptanceResult.goodsTotal = parseInt(this.fdAcceptanceResult.goodsTotal || 0 )

                    if (this.fdAcceptanceResult.goodsTotal > 0 && this.fdAcceptanceResult.unqualifiedQuantity > 0) {
                        this.fdAcceptanceResult.rejectRatio = this.fdAcceptanceResult.unqualifiedQuantity / this.fdAcceptanceResult.goodsTotal * 100
                    } else {
                        this.fdAcceptanceResult.rejectRatio = '--'
                    }

                    let checkImgs = [];		
                    console.log(this.fdAcceptanceResult.checkImgs);
                    this.fdAcceptanceResult.checkImgs.forEach(item => {
                        checkImgs = checkImgs.concat(item.name);
                    });

                    let arg = {
                        userId: this.fdUserId,
                        orderNumber: this.orderNumber,
                        imageJson: JSON.stringify(checkImgs) === '[]' ? '' : JSON.stringify(checkImgs),
                        acceptanceResultsDescription: this.fdAcceptanceResult.acceptanceResultsDescription,
                        submitAcceptanceResultsAdminRemark: this.fdAcceptanceResult.submitAcceptanceResultsAdminRemark,
                        unqualifiedQuantity: this.fdAcceptanceResult.unqualifiedQuantity,
                        goodsTotal: this.fdAcceptanceResult.goodsTotal,
                        rejectRatio: this.fdAcceptanceResult.rejectRatio,
                    }
                    ajaxApp('/yijiajiaOrder/submitAcceptanceResults',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.fdAcceptanceResultShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.fdAcceptanceResult.loading = false
                    }, err => {
                        this.fdAcceptanceResult.loading = false
                        console.log(err)
                    })
                })
            },

            // 发单方 - 上传交付款支付凭证 提交
            fdPayDeliveryVoucherSubmit() {
                // if (
				// 	this.fdPayDeliveryVoucher.deliveryPayImgs.length == 0 && this.fdPayDeliveryVoucher.deliveryRemark == ''
				// ) {
				// 	this.$message({
                //         type: 'warning',
                //         message: '至少填写一项!'
                //     })
				// 	return false;
                // }

                if (
					this.fdPayDeliveryVoucher.deliveryAdminRemark == ''
				) {
					this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
					return false;
                }
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fdPayDeliveryVoucher.loading = true;

                    let deliveryPayImgs = [];		
                    console.log(this.fdPayDeliveryVoucher.deliveryPayImgs);
                    this.fdPayDeliveryVoucher.deliveryPayImgs.forEach(item => {
                        deliveryPayImgs = deliveryPayImgs.concat(item.name);
                    });

                    let arg = {
                        userId: this.fdUserId,
                        orderNumber: this.orderNumber,
                        imageJson: JSON.stringify(deliveryPayImgs) === '[]' ? '' : JSON.stringify(deliveryPayImgs),
                        deliveryRemark: this.fdPayDeliveryVoucher.deliveryRemark,
                        deliveryAdminRemark: this.fdPayDeliveryVoucher.deliveryAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/deliveryCertificate',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.fdPayDeliveryVoucherShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.fdPayDeliveryVoucher.loading = false
                    }, err => {
                        this.fdPayDeliveryVoucher.loading = false
                        console.log(err)
                    })
                })
            },

            // 发单方 - 上传尾款支付凭证 提交
            fdPayFinalVoucherSubmit() {
                // if (
				// 	this.fdPayFinalVoucher.finalPayImgs.length == 0 && this.fdPayFinalVoucher.tailRemark == ''
				// ) {
				// 	this.$message({
                //         type: 'warning',
                //         message: '至少填写一项!'
                //     })
				// 	return false;
                // }
                if (
					this.fdPayFinalVoucher.tailAdminRemark == ''
				) {
					this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
					return false;
                }

                
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fdPayFinalVoucher.loading = true;

                    let finalPayImgs = [];		
                    console.log(this.fdPayFinalVoucher.finalPayImgs);
                    this.fdPayFinalVoucher.finalPayImgs.forEach(item => {
                        finalPayImgs = finalPayImgs.concat(item.name);
                    });

                    let arg = {
                        userId: this.fdUserId,
                        orderNumber: this.orderNumber,
                        imageJson: JSON.stringify(finalPayImgs) === '[]' ? '' : JSON.stringify(finalPayImgs),
                        tailRemark: this.fdPayFinalVoucher.tailRemark,
                        tailAdminRemark: this.fdPayFinalVoucher.tailAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/tailCertificate',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.fdPayFinalVoucherShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.fdPayFinalVoucher.loading = false
                    }, err => {
                        this.fdPayFinalVoucher.loading = false
                        console.log(err)
                    })
                })
            },
        
            // 发单方 - 对厂家评价 提交
            fdCommentSubmit() {
                console.log(this.fdComment)
                if (
					this.fdComment.stars == 0
				) {
					this.$message({
                        type: 'warning',
                        message: '请先评价!'
                    })
					return false;
                }
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fdComment.loading = true;

                    let arg = {
                        userId: this.fdUserId,
                        orderNumber: this.orderNumber,
                        score: this.fdComment.stars,
                        evaluationMsg: this.fdComment.evaluationMsg
                    }
                    ajaxApp('/yijiajiaOrder/evaluation',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.fdCommentShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.fdComment.loading = false
                    }, err => {
                        this.fdComment.loading = false
                        console.log(err)
                    })
                })
            },

            // 接单方 - 对品牌商评价 提交
            jdCommentSubmit() {
                console.log(this.fdComment)
                if (
					this.jdComment.stars == 0
				) {
					this.$message({
                        type: 'warning',
                        message: '请先评价!'
                    })
					return false;
                }
                
                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.jdComment.loading = true;

                    let arg = {
                        userId: this.jdUserId,
                        orderNumber: this.orderNumber,
                        score: this.jdComment.stars,
                        evaluationMsg: this.jdComment.evaluationMsg
                    }
                    ajaxApp('/yijiajiaOrder/evaluation',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.jdCommentShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.jdComment.loading = false
                    }, err => {
                        this.jdComment.loading = false
                        console.log(err)
                    })
                })
            },

            // 获取数据 -- 确认合同 / 确认定金支付凭证 / 确认交货款支付凭证
            checkInfo(flag) {
                if (flag === 'jd_check_contract') {
                    this.jdCheckContractShow = true;
                }
                if (flag === 'jd_check_pay_advance_voucher') {
                    this.jdCheckPayAdvanceVoucherShow = true;
                }
                if (flag === 'jd_check_pay_delivery_voucher') {
                    this.jdCheckPayDeliveryVoucherShow = true;
                }

                if (flag === 'jd_check_pay_tail_voucher') {
                    this.jdCheckPayTailVoucherShow = true;
                }

                if (flag === 'see_contract') {
                    this.seeContractShow = true;
                }

                if (flag === 'see_pay_advance_voucher') {
                    this.seePayAdvanceVoucherShow = true;
                }

                if (flag === 'see_goods') {
                    this.seeGoodsShow = true;
                }

                if (flag === 'see_pay_delivery_voucher') {
                    this.seePayDeliveryVoucherShow = true;
                }

                if (flag === 'see_pay_tail_voucher') {
                    this.seePayTailVoucherShow = true;
                }

                if (flag === 'see_comment') {
                    this.seeCommentShow = true;
                }

                if (flag === 'see_producer_cancel_reason') {
                    this.seeProducerCancelReasonShow = true;
                }
                
                ajaxApp('/yijiajiaOrder/paymentRemarkShow', {orderNumber: this.orderNumber}).then(res => {
                    console.log(res)
                    if (res.errorCode === 200) {
                        if (flag === 'jd_check_contract') {
                            this.jdCheckContract.contractRemarkImg = res.data.contractRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.jdCheckContract.contractRemark = res.data.contractRemark
                            this.seeContract.contractAdminRemark = res.data.contractAdminRemark
                        }

                        if (flag === 'jd_check_pay_advance_voucher') {
                            this.jdCheckPayAdvanceVoucher.paymentRemarkImg = res.data.paymentRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.jdCheckPayAdvanceVoucher.prepaymentRemark = res.data.prepaymentRemark
                        }

                        if (flag === 'jd_check_pay_delivery_voucher') {
                            this.jdCheckPayDeliveryVoucher.deliveryRemarkImg = res.data.deliveryRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.jdCheckPayDeliveryVoucher.deliveryRemark = res.data.deliveryRemark
                        }

                        if (flag === 'jd_check_pay_tail_voucher') {
                            this.jdCheckPayTailVoucher.tailRemarkImg = res.data.tailRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.jdCheckPayTailVoucher.tailRemark = res.data.tailRemark
                        }

                        if (flag === 'see_contract') {
                           this.seeContract.contractRemarkImg = res.data.contractRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seeContract.contractRemark = res.data.contractRemark
                            this.seeContract.contractAdminRemark = res.data.contractAdminRemark
                        }

                        if (flag === 'see_pay_advance_voucher') {
                            this.seePayAdvanceVoucher.paymentRemarkImg = res.data.paymentRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seePayAdvanceVoucher.prepaymentRemark = res.data.prepaymentRemark
                            this.seePayAdvanceVoucher.prepaymentAdminRemark = res.data.prepaymentAdminRemark 
                        }

                        if (flag === 'see_goods') {
                            this.seeGoods.deliverImg = res.data.deliverImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seeGoods.deliverDescription = res.data.deliverDescription
                            this.seeGoods.deliverQuantity = res.data.deliverQuantity
                            this.seeGoods.deliverLargeGoodsAdminRemark = res.data.deliverLargeGoodsAdminRemark 
                        } 
                        
                        if (flag === 'see_pay_delivery_voucher') {
                            this.seePayDeliveryVoucher.deliveryRemarkImg = res.data.deliveryRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seePayDeliveryVoucher.deliveryRemark = res.data.deliveryRemark
                            this.seePayDeliveryVoucher.deliveryAdminRemark = res.data.deliveryAdminRemark
                            
                        }

                        if (flag === 'see_pay_tail_voucher') {
                            this.seePayTailVoucher.tailRemarkImg = res.data.tailRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seePayTailVoucher.tailRemark = res.data.tailRemark
                            this.seePayTailVoucher.tailAdminRemark = res.data.tailAdminRemark
                        }

                        if (flag === 'see_comment') {
                            this.seeComment.comment_score = res.data.comment_score
                            this.seeComment.comment_info = res.data.comment_info
                            this.seeComment.producer_comment_score = res.data.producer_comment_score
                            this.seeComment.producer_comment_info = res.data.producer_comment_info
                        }

                        if (flag === 'see_producer_cancel_reason') {
                            this.seeProducerCancelReason.producerCancelImg = res.data.producerCancelImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seeProducerCancelReason.producerCancellationOfOrder = res.data.producerCancellationOfOrder
                        }
                    } 
                }, err => {
                    console.log(err)
                })
            },
            // 查看补充资料
			getAdditionalData () {
                this.seeAdditionalDataShow = true
                ajaxApp('/yijiajiaOrder/additionalMaterialsShow', { userId: this.fdUserId, orderNumber: this.orderNumber, orderType: this.fdInfo.order_type}).then(res => {
                    console.log(res)
                    if (res.errorCode === 200) {
                        this.seeAdditionalData.orderAdditionalMaterials = res.data.orderAdditionalMaterials ? res.data.orderAdditionalMaterials : {}
                        if (res.data.orderAdditionalMaterialsPic) {
                            if (res.data.orderAdditionalMaterialsPic.checkGoodsImg) {
                                this.seeAdditionalData.checkGoodsImg = res.data.orderAdditionalMaterialsPic.checkGoodsImg.map(item => {
                                    return  {
                                        ...item,
                                        image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                    }
                                })
                            }
                            if (res.data.orderAdditionalMaterialsPic.sizeTableImg) {
                                this.seeAdditionalData.sizeTableImg = res.data.orderAdditionalMaterialsPic.sizeTableImg.map(item => {
                                    return  {
                                        ...item,
                                        image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                    }
                                })
                            }
                            if (res.data.orderAdditionalMaterialsPic.technologyImg) {
                                this.seeAdditionalData.technologyImg = res.data.orderAdditionalMaterialsPic.technologyImg.map(item => {
                                    return  {
                                        ...item,
                                        image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                    }
                                })
                            }
                        }
                    } 
                }, err => {
                    console.log(err)
                }) 
			},
            // 查看验收结果
            seeResultData() {
                this.seeResultShow = true;
                ajaxApp('/yijiajiaOrder/confirmAcceptanceResultsshow', {orderNumber: this.orderNumber}).then(res => {
                    console.log(res)
                    if (res.errorCode === 200) {
                        if (res.data.acceptanceImg) {
                            this.seeResult.acceptanceImg = res.data.acceptanceImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                        }
                        
                        this.seeResult.description = res.data.description
                        this.seeResult.goodsTotal = res.data.goodsTotal
                        this.seeResult.quantity = res.data.quantity
                        this.seeResult.rejectRatio = res.data.rejectRatio
                        this.seeResult.submitAcceptanceResultsAdminRemark = res.data.submitAcceptanceResultsAdminRemark
                        
                    } 
                }, err => {
                    console.log(err)
                }) 
            },
            // 获取数据 - 验收结果
            getSureResultData() {
                this.jdSureResultShow = true;
                ajaxApp('/yijiajiaOrder/confirmAcceptanceResultsshow', {orderNumber: this.orderNumber}).then(res => {
                    console.log(res)
                    if (res.errorCode === 200) {
                        if (res.data.acceptanceImg) {
                            this.jdSureResult.acceptanceImg = res.data.acceptanceImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                        }
                        this.jdSureResult.description = res.data.description
                        this.jdSureResult.goodsTotal = res.data.goodsTotal
                        this.jdSureResult.quantity = res.data.quantity
                        this.jdSureResult.rejectRatio = res.data.rejectRatio
                    } 
                }, err => {
                    console.log(err)
                }) 
            },

            // 确认合同 - 提交确认
            jdCheckContractSubmit() {
                if (this.jdCheckContract.confirmContractAdminRemark === '') {
                    this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
                    return false;
                }

                this.$confirm('您确定品牌商的合同准确无误吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.jdCheckContract.loading = true;

                    let arg = {
                        userId: this.jdUserId,
                        orderNumber: this.orderNumber,
                        confirmContractAdminRemark: this.jdCheckContract.confirmContractAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/confirmContract',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.jdCheckContractShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.jdCheckContract.loading = false
                    }, err => {
                        this.jdCheckContract.loading = false
                        console.log(err)
                    })
                })
            },

            // 确认定金支付凭证
            jdCheckPayAdvanceVoucherSubmit() {
                if (this.jdCheckPayAdvanceVoucher.confirmCertificateAdminRemark === '') {
                    this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
                    return false;
                }

                this.$confirm('您确定品牌商提交的定金支付凭证准确无误吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.jdCheckPayAdvanceVoucher.loading = true;

                    let arg = {
                        userId: this.jdUserId,
                        orderNumber: this.orderNumber,
                        confirmCertificateAdminRemark: this.jdCheckPayAdvanceVoucher.confirmCertificateAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/confirmCertificate',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.jdCheckPayAdvanceVoucherShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.jdCheckPayAdvanceVoucher.loading = false
                    }, err => {
                        this.jdCheckPayAdvanceVoucher.loading = false
                        console.log(err)
                    })
                })
            },

            // 接单方 - 交付大货
            jdDeliverGoodsSubmit() {
                if (this.jdDeliverGoods.deliverLargeGoodsAdminRemark === '') {
                    this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
                    return false;
                }

                this.$confirm('您确定提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.jdDeliverGoods.loading = true;

                    let deliverLargeGoodsImgs = [];		
                    console.log(this.jdDeliverGoods.deliverLargeGoodsImgs);
                    this.jdDeliverGoods.deliverLargeGoodsImgs.forEach(item => {
                        deliverLargeGoodsImgs = deliverLargeGoodsImgs.concat(item.name);
                    });

                    let arg = {
                        userId: this.jdUserId,
                        orderNumber: this.orderNumber,
                        imageJson: JSON.stringify(deliverLargeGoodsImgs) === '[]' ? '' : JSON.stringify(deliverLargeGoodsImgs),
                        deliverQuantity: this.jdDeliverGoods.deliverQuantity,
                        deliverDescription: this.jdDeliverGoods.deliverDescription,
                        deliverLargeGoodsAdminRemark: this.jdDeliverGoods.deliverLargeGoodsAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/deliverLargeGoods',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.jdDeliverGoodsShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.jdDeliverGoods.loading = false
                    }, err => {
                        this.jdDeliverGoods.loading = false
                        console.log(err)
                    })
                })
            },
            // 接单方 - 确认验收结果
            jdSureResultSubmit() {
                if (this.jdSureResult.confirmAcceptanceResultsAdminRemark === '') {
                    this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
                    return false;
                }

                this.$confirm('您确定品牌商的验收结果无误吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.jdSureResult.loading = true;

                    let arg = {
                        userId: this.jdUserId,
                        orderNumber: this.orderNumber,
                        confirmAcceptanceResultsAdminRemark: this.jdSureResult.confirmAcceptanceResultsAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/confirmAcceptanceResults',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.jdSureResultShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.jdSureResult.loading = false
                    }, err => {
                        this.jdSureResult.loading = false
                        console.log(err)
                    })
                })
            },

            // 确认交货款支付凭证
            jdCheckPayDeliveryVoucherSubmit() {
                if (this.jdCheckPayDeliveryVoucher.confirmDeliveryAdminRemark === '') {
                    this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
                    return false;
                }

                this.$confirm('您确定品牌商提交的交货款支付凭证准确无误吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.jdCheckPayDeliveryVoucher.loading = true;

                    let arg = {
                        userId: this.jdUserId,
                        orderNumber: this.orderNumber,
                        confirmDeliveryAdminRemark: this.jdCheckPayDeliveryVoucher.confirmDeliveryAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/confirmDelivery',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.jdCheckPayDeliveryVoucherShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.jdCheckPayDeliveryVoucher.loading = false
                    }, err => {
                        this.jdCheckPayDeliveryVoucher.loading = false
                        console.log(err)
                    })
                })
            },

            // 确认尾款支付凭证
            jdCheckPayTailVoucherSubmit() {
                if (this.jdCheckPayTailVoucher.confirmConfirmTailAdminRemark === '') {
                    this.$message({
                        type: 'warning',
                        message: '管理员备注信息为必填!'
                    })
                    return false;
                }

                this.$confirm('您确定品牌商提交的尾款支付凭证准确无误吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.jdCheckPayTailVoucher.loading = true;

                    let arg = {
                        userId: this.jdUserId,
                        orderNumber: this.orderNumber,
                        confirmConfirmTailAdminRemark: this.jdCheckPayTailVoucher.confirmConfirmTailAdminRemark
                    }
                    ajaxApp('/yijiajiaOrder/confirmTail',arg).then(res => {
                        console.log(res)
                        if (res.errorCode === 200) {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.getFdOrderProgress()
                            this.jdCheckPayTailVoucherShow = false
                        } else {
                            this.$message({
                                message: '提交失败！',
                                type: 'warning'
                            })
                        }
                        this.jdCheckPayTailVoucher.loading = false
                    }, err => {
                        this.jdCheckPayTailVoucher.loading = false
                        console.log(err)
                    })
                })
            },


            // 图片上传相关
            // 图片上传 提交服务器之前
            beforeUpload(file) {
                console.log('this.fdAddInfo.data', this.fdAddInfo.data)
                console.log('beforeUpload', file)
                if (!(file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')) {
                    this.$message({
                        type: 'warning',
                        message: '必须为图片且要求是.png或.jpg格式!'
                    })
                    return false
                } else if (file.size > 10 * 1024 * 1024) {
                    this.$message({
                        type: 'warning',
                        message: '图片大小不能超过10M!'
                    })
                    return false
                }
            },
            // 图片上传成功
            onSuccess(response, file, fileList, data, imgs) {
                console.log('onSuccess', response, file, fileList, data, imgs)
                let editIndex;
                fileList.forEach((item,index) => {
                    if (item.uid == file.uid) {
                        editIndex = index;
                    }
                })
                this[data][imgs] = fileList;
                let imgIds = response.data.split(',').map(item => JSON.parse(item));
                this[data][imgs][editIndex].name = imgIds;
                console.log(data, imgs, this[data][imgs])
            },
            // 图片上传失败
            onError(err, file, fileList) {
                console.log('onError', err, file, fileList)
                this.$message({
                    type: 'error',
                    message: '图片上传失败!'
                })
            },
            // 图片预览
            handlePictureCardPreview(file) {
                if (file.url) {
                    this.dialogImageUrl = file.url
                    this.dialogVisible = true
                }

                if (file.image_file) {
                    this.dialogImageUrl = file.image_file
                    this.dialogVisible = true
                }
                
                console.log(file)
            },
            // 图片删除
            handleRemove(file, fileList, imgsData) {
                console.log(file, fileList, imgsData)
                this[imgsData] = fileList
                // this.$refs.ruleForm.validateField('fileList')
            },

            // 获取订单动态数据 -- 发单方
            getFdOrderProgress() {
                let _this = this
                let arg = {
                    orderNumber: this.orderNumber,
                    userId: this.fdUserId
                }
                ajaxApp('/yijiajiaOrder/orderProgressPinpai',arg).then(function(res){
                    console.log(res)
                     _this.fdOrderDynamics = []
                    // res.data.orderDynamic
                    for(let i=0; i<res.data.orderDynamics.length; i++) {
                        let item=res.data.orderDynamics[i]
                        let buffer={}
                        buffer.record_time=item.record_time
                        console.log(item.log_text)
                        if (item.log_text.search("{")>-1) {
                            buffer.log_text=JSON.parse(item.log_text)
                        } else {
                            let textArr=[]
                            let textObj={
                                str:item.log_text
                            }
                            textArr.push(textObj)
                            let temp={
                                text:textArr
                            }
                            buffer.log_text=temp
                        }
                        if (item.log_text.lastIndexOf('。') > -1) {
                            buffer.isAdmin = true
                        } else {
                            buffer.isAdmin = false
                        }
                        _this.fdOrderDynamics.push(buffer);
                    }


                    _this.fdInfo = res.data.info;
                    _this.fdInfo.advance_payment_percent = parseInt(_this.fdInfo.order_advance_payment_percent || 0);
                    _this.fdInfo.delivery_payment_percent = parseInt(_this.fdInfo.order_delivery_payment_percent || 0);
                    _this.fdInfo.tail_payment_percent = 100 - parseInt(_this.fdInfo.order_advance_payment_percent || 0) - parseInt(_this.fdInfo.order_delivery_payment_percent || 0);
                    // console.log(_this.fdInfo)
                    if (res.data.info.order_status > 10300) {
                        if (res.data.jiedanfang && res.data.jiedanfang[0]) {
                            _this.jdUserId = res.data.jiedanfang[0].user_id
                            _this.getJdOrderProgress({
                                orderNumber: _this.orderNumber,
                                userId: res.data.jiedanfang[0].user_id
                            })
                        }
                        
                    }
                },function(err){
                    console.log(err)
                })
            },
            // 获取订单动态数据 -- 接单方
            getJdOrderProgress(arg) {
                let _this = this;
                ajaxApp('/yijiajiaOrder/orderProgressShengchan',arg).then(function(res){
                    console.log(res)
                    _this.jdOrderDynamics = []
                    for(let i=0; i<res.data.orderDynamics.length; i++) {
                        let item=res.data.orderDynamics[i]
                        let buffer={}
                        buffer.record_time=item.record_time
                        console.log(item.log_text)
                        if (item.log_text.search("{")>-1) {
                                buffer.log_text=JSON.parse(item.log_text)
                        } else {
                            let textArr=[]
                            let textObj={
                                str:item.log_text
                            }
                            textArr.push(textObj)
                            let temp={
                                text:textArr
                            }
                            buffer.log_text=temp
                        }
                        if (item.log_text.lastIndexOf('。') > -1) {
                            buffer.isAdmin = true
                        } else {
                            buffer.isAdmin = false
                        }
                        _this.jdOrderDynamics.push(buffer);
                        _this.jdInfo = res.data.info;
                    }
                },function(err){
                    console.log(err)
                })
            },

            // 查看动态详情
            seeDynamicsDetail(link) {
                console.log(link)
				if(link=='补充详细资料'){
					this.getAdditionalData();
					return false;
				}
				if(link=='合同'){
					this.checkInfo('see_contract');
					return false;
				}
				if(link=='定金'){
                    this.checkInfo('see_pay_advance_voucher');
					return false;
				}
				if(link=='交货款'){
					this.checkInfo('see_pay_delivery_voucher');
					return false;
				}
				if(link=='尾款'){
					this.checkInfo('see_pay_tail_voucher');
					return false;
				}
				if(link=='评价'){
					this.checkInfo('see_comment')
					return false;
					
				}
			    if(link=='验收'){
				    this.seeResultData();
					return false;
			    }
				if(link=='大货'){//查看大货详情
					this.checkInfo('see_goods');
					return false;
				}
				if(link=='取消订单'){// 查看生产商取消原因
					this.checkInfo('see_producer_cancel_reason');
					return false;
				}
				if(link=='查看原因'){//查看原因
// 					this.toCheckCancelReason();
// 					return false;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .order-header {
        margin: 15px;
        background: #fff;
        padding: 15px;
        line-height: 1.5;
        font-size: 15px;
    }

    .order-btns-wrap {
        margin: 15px;
        background: #fff;
        padding: 15px;
        .cancel-btn {
            margin-top: 15px;
            margin-bottom: 15px;
            .status {
                margin-left: 30px;
                font-size: 18px;
                .act {
                    color: #0e85ea
                }
            }
        }
        .steps {
            display: flex;
            flex-wrap: wrap;
            border: 1px dashed #eee;
            padding-top: 20px;

            .items {
                width: 170px;
                
                // background: #eee;
                margin:0 60px 20px 0;
                position: relative;
                // border: 1px solid #eee;
                // border-radius: 4px;
                // box-shadow: 0 0 10px #eee;

                // .status {
                //     text-align: center;
                //     line-height: 30px;
                //     height: 30px;
                //     font-size: 14px;
                //     background: #eee;
                // }
                .btn {
                    // height: 70px;
                    text-align: center;
                    .el-button {
                        margin-top: 10px;
                    }    
                }

                &::before {
                    position: absolute;
                    top: 21px;
                    left: 180px;
                    width: 20px;
                    height: 10px;
                    content: ' ';
                    background: #aaa;
                }
                &::after {
                    position: absolute;
                    top: 12px;
                    left: 200px;
                    width: 0px;
                    height: 0px;
                    content: ' ';
                    border: 14px solid transparent;
                    border-left: 20px solid #aaa;
                }
               
                &:last-child::before { width: 0; }
                &:last-child::after { border: none; }
            }
        }
    }

    .content {
        display: flex;
        margin: 15px;
        .content-item {
            width: 50%;
            background: #fff;
            padding: 15px;
            .title {
                line-height: 1;
                font-size: 15px;
                border-left: 3px solid #3C9FDB;
                padding-left: 20px;
                font-weight: bold;
                margin-bottom: 20px;

                .status {
                    color: #0e85ea;
                }
            }
            .btns {
                padding: 10px;
            }
            .progress {
                min-height: 200px;
                padding: 20px 10px;
                span.active-text {
                    color: #2b87d6;
                    &:hover {
                        text-decoration: underline;
                        color: #0e85ea;
                        cursor: pointer;
                    }
                }
                .no-dynamics {
                    margin-top: 60px;
                    // text-align: center;
                    margin-left: 20px;
                    color: #999;
                }
            }
            // .mod-title {
            //     line-height: 1.2;
            //     font-size: 13px;
            //     padding: 4px 10px;
            //     background:  #dcdfe6; 
            //     font-weight: bold;
            // }
        }
    }
    .mod-title {
        line-height: 1;
        font-size: 15px;
        border-left: 3px solid #3C9FDB;
        padding-left: 20px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .el-rate {margin-top: 10px;}
    .el-form-item__label {font-weight: bold;}
    .admin-flag {margin-left: 10px;}
</style>



// WEBPACK FOOTER //
// src/pages/order/progressEdit.vue